import React from "react";
import PropTypes from "prop-types";

export default class AudioFile extends React.Component {
  abortController = new AbortController();

  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount = () => {
    fetch(`/services/getAudioJSON?audioId=${this.props.audioId}`, {
      headers: {
        "content-type": "application/json",
      },
      method: "GET",
      cache: "no-cache",
      signal: this.abortController.signal,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((resp) => {
        const audioResponse = resp.response;
        this.setState({ loaded: true, audiofile: audioResponse });
      });
  };

  componentWillUnmount = () => {
    this.abortController.abort();
  };

  render = () => {
    if (this.state.loaded) {
      return <span>{this.state.audiofile.Name}</span>;
    }
    return (
      <span>
        <img src="/_client/images/global/ui-loader-1.gif" />
      </span>
    );
  };
}

AudioFile.propTypes = {
  audioId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
